import { ExtractAtomValue } from 'jotai';
import { displayTasksAtom, pollingTaskAtom, prepareTaskAtom } from './@atoms';
import { TaskWithResult } from './@types';

type DerivedAtomState = (
  | ExtractAtomValue<typeof displayTasksAtom>
  | ExtractAtomValue<typeof prepareTaskAtom>
  | ExtractAtomValue<typeof pollingTaskAtom>
)[number];

export const getTaskParamFromTaskDescription = <ResultType>(
  taskDescription: DerivedAtomState,
  updatedTaskDescription?: Partial<TaskWithResult<ResultType>>
): TaskWithResult<ResultType> => {
  return Object.assign(
    {
      taskId: taskDescription.taskId,
      processId: taskDescription.processId,
      fileName: taskDescription.fileName,
      fileType: taskDescription.fileType,
      status: taskDescription.status,
    },
    updatedTaskDescription
  );
};
